"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const CharacterCount_1 = __importDefault(require("components/cosmos/CharacterCount"));
const Textarea_1 = __importDefault(require("components/cosmos/Textarea"));
const translate_1 = require("components/translate");
const StarRating_1 = __importDefault(require("./StarRating"));
const constants_1 = require("../constants");
const ReviewOverlay_module_scss_1 = __importDefault(require("./ReviewOverlay.module.scss"));
const ReviewOverlay = ({ t, title, onSubmit, onClose }) => {
    const [rating, setRating] = (0, react_1.useState)(constants_1.INITIAL_RATING_VALUE);
    const [comment, setComment] = (0, react_1.useState)('');
    const submitIsDisabled = !rating;
    const handleSubmit = () => {
        return onSubmit({ rating, comment });
    };
    const handleRatingChange = (newValue) => {
        setRating((previousValue) => {
            return previousValue === newValue ? constants_1.INITIAL_RATING_VALUE : newValue;
        });
    };
    const handleCommentChange = (event) => {
        setComment(event.target.value.substring(0, constants_1.COMMENT_MAX_LENGTH));
    };
    return ((0, jsx_runtime_1.jsxs)("section", { className: ReviewOverlay_module_scss_1.default.overlay, children: [(0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _justify-content-between _mb-3", children: [(0, jsx_runtime_1.jsx)("span", { className: "_text-2 _text-gray-800", children: title }), (0, jsx_runtime_1.jsx)("button", { onClick: onClose, "aria-label": t('reviews.close_overlay_aria'), children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'xmark'] }) })] }), (0, jsx_runtime_1.jsx)(StarRating_1.default, { value: rating, onChange: handleRatingChange }), (0, jsx_runtime_1.jsxs)("div", { className: "_my-4", children: [(0, jsx_runtime_1.jsx)("label", { className: "_text-2 _text-gray-800 _mb-2", htmlFor: "reviewComment", children: t('reviews.comment_title') }), (0, jsx_runtime_1.jsx)(Textarea_1.default, { className: "_mb-1", value: comment, onChange: handleCommentChange, rows: 4, placeholder: t('reviews.comment_placeholder'), id: "reviewComment" }), (0, jsx_runtime_1.jsx)(CharacterCount_1.default, { text: comment, max: constants_1.COMMENT_MAX_LENGTH })] }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", onClick: handleSubmit, disabled: submitIsDisabled, className: "_float-right", children: t('reviews.submit') })] }));
};
exports.default = (0, translate_1.translate)()(ReviewOverlay);
